module.exports = __webpack_public_path__ + "img/slideshow.0061bd76.svg";